import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const variants = {
  default: {
    backgroundColor: 'var(--background-card)',
    border: '1px solid var(--border)'
  },
  subtle: {
    backgroundColor: 'var(--primary-light)',
    border: '1px solid var(--primary-light)'
  },
  outlined: {
    backgroundColor: 'transparent',
    border: '1px solid var(--border)'
  }
};

const InfoCard = ({
  label,
  value,
  color = 'var(--primary)',
  variant = 'default',
  align = 'center',
  ...props
}) => {
  const variantStyles = variants[variant] || variants.default;

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        textAlign: align,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        transition: 'box-shadow 0.3s ease, transform 0.2s ease',
        '&:hover': {
          boxShadow: '0 4px 14px rgba(0,0,0,0.15)',
          transform: 'translateY(-2px)'
        },
        ...variantStyles,
        ...props.sx
      }}
      {...props}
    >
      <Typography
        variant="body2"
        sx={{
          color: 'var(--text-muted)',
          fontSize: '0.75rem',
          mb: 0.5,
          fontWeight: 500,
          letterSpacing: 0.5
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          color: color,
            fontWeight: 600,
          fontSize: '1.1rem'
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};

InfoCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  color: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'subtle', 'outlined']),
  align: PropTypes.oneOf(['left', 'center', 'right']),
  sx: PropTypes.object
};

export default InfoCard;